import classNames from 'classnames'

/**
 * Estilos base compartilhados para todos os inputs do sistema
 */
export const getInputBaseClasses = (
  error?: boolean,
  disabled?: boolean,
  hasLeftIcon?: boolean,
  additionalClasses?: string
) => {
  return classNames(
    // Estilos base
    'w-full h-11 px-3 py-2 border rounded-xl shadow-sm',
    'transition-colors duration-200',
    
    // Estados de focus
    'focus:outline-none focus:ring-4 focus:ring-blue-500/10 focus:border-blue-600',
    
    // Estados de hover (apenas quando não está desabilitado e não tem erro)
    !disabled && !error && 'hover:border-blue-400',
    
    // Estados desabilitados
    disabled && 'bg-gray-50 text-gray-500 cursor-not-allowed',
    
    // Estados de erro
    {
      'border-red-300 focus:border-red-500 focus:ring-red-500/10': error,
      'border-gray-200': !error,
      'pl-10': hasLeftIcon
    },
    
    additionalClasses
  )
}

/**
 * Estilos base para textarea (sem altura fixa)
 */
export const getTextareaBaseClasses = (
  error?: boolean,
  disabled?: boolean,
  additionalClasses?: string
) => {
  return classNames(
    // Estilos base
    'w-full px-3 py-2 border rounded-xl shadow-sm min-h-[100px]',
    'transition-colors duration-200',
    
    // Estados de focus
    'focus:outline-none focus:ring-4 focus:ring-blue-500/10 focus:border-blue-600',
    
    // Estados de hover (apenas quando não está desabilitado e não tem erro)
    !disabled && !error && 'hover:border-blue-400',
    
    // Estados desabilitados
    disabled && 'bg-gray-50 text-gray-500 cursor-not-allowed',
    
    // Estados de erro
    {
      'border-red-300 focus:border-red-500 focus:ring-red-500/10': error,
      'border-gray-200': !error
    },
    
    additionalClasses
  )
}

/**
 * Estilos para labels de inputs
 */
export const getInputLabelClasses = () => {
  return 'block text-sm font-medium text-gray-700 mb-1.5'
}

/**
 * Estilos para helper text de inputs
 */
export const getInputHelperTextClasses = (error?: boolean) => {
  return classNames('mt-1.5 text-sm', {
    'text-red-500': error,
    'text-gray-500': !error
  })
}

